<template>
    <div class="container">
        <div class="spacer"></div>
        <div class="d-flex align-items-top">
            <RouterLink :to="{name: 'Dashboard'}" class="fa-2x fas text-info text-decoration-none fa-arrow-alt-circle-left mr-2"></RouterLink>
            <h1 class="h3">Mensajes de contacto </h1>
        </div>
        
        <section class="mt-4">
            
            <div class="d-flex flex-column mb-4 p-3 card bg-light" v-for="(message, index) in messages" :key="index">

                <div class="flex-shrink-0">
                    <div class="d-inline h4" v-if="!message.read">
                        <span class="badge badge-warning mb-2">Sin Leer</span><br/>
                    </div>

                    <button type="button" class="btn btn-success mr-2" @click="setRead(message.messageId)">
                        <i class="fa-check fa-lg fas"></i>
                    </button>
                    
                    <button type="button" class="btn btn-danger mr-3" @click="doDelete(message.messageId)">
                        <i class="fa-lg fa-trash fas"></i>
                    </button>
                </div>

                <div class="mb-2 mt-4">
                    <h3 class="font-weight-bold h5">
                        {{message.name}}
                    </h3>
                    <span class="lead">{{message.contact}}</span>
                </div>

                <div class="pt-2">
                    <p>{{message.message | maxLength(200, index, showAllMessage)}} <a class="text-info pointer" v-show="!showAllMessage.some(item => item == index)" @click="showAllMessage.push(index)">Ver más</a></p>
                </div>               
            </div>
            <div v-show="!messages.length">
                <h4> No hay mensajes para ver </h4>
                <div class="vh-100"></div>
            </div>

        </section>


    </div>
</template>
<script>
export default {
    name: 'messages',
    created(){
        if(!this.messages.length){
            this.$store.dispatch('message/getMessages')
        }
    },
    data(){
        return{
            showAllMessage: []
        }
    },
    computed:{
        messages(){
            return this.$store.state.message.messages
        }
    },
    methods:{
        setRead(id){
            this.$store.dispatch('message/setRead', id)
        },
        doDelete(id){
            if(window.confirm('¿Realmente desea eliminar el mensaje?')){
                this.$store.dispatch('message/doDelete', id)
            }
        },
    },
    filters:{
        maxLength(message, length, index, showAllMessage){
            
            if(message.length > length && !showAllMessage.some(item => item==index)){
                return `${message.substring(0, length)}...`
            }else{
                return message
            }
        }
    }
}
</script>